<template>
  <div class="ranking-question-box">
    <el-checkbox-group v-model="checkboxGroup" @input="changeChecked()" size="small" :max="getMax">
      <div v-for="(item, index) in getLabels" :key="index">
        <el-checkbox :label="item.item.id" @click.native="stopDefault($event)" border>
          <div style="width: 100%; display: flex">
            <span class="___img-class" v-html="transformHtml(item.item.content.richText || item.item.content.text)"></span>
            <!-- <div style="display:inline-block;margin-right:5px;" v-for="(img,ids) in getImg(item.item)" :key="ids">
              <el-image 
                v-show="img"
                style="width: 20px; height: 20px;"
                :z-index="5000"
                :src="img"
                :preview-src-list="getImg(item.item)"
                />
            </div> -->
          </div>
          <span :class="item.order ? 'round activeRound' : 'round'">{{ item.order }}</span>
        </el-checkbox>
      </div>
    </el-checkbox-group>
  </div>
</template>

<script>
import '../public/style.css'
import mixins from '../mixins'
import { itemInitOptions } from '../config/config.js'
import { saveArr } from '../public/index.js'

export default {
  mixins: [mixins],
  name: 'sort',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      checkboxGroup: [],
      rowDataItems: JSON.parse(JSON.stringify(this.rowData.items))
    }
  },
  computed: {
    getRichText() {
      return (id)=>{
        const one = this.rowDataItems.find(item => item.optionId === id)
        return one?.value
      }
    },
    getLabels() {
      let checkedArr = []
      let noCkeckedArr = []
      let order = this.checkboxGroup
      let issueItems = this.rowData.questionDetails.issue.items.map(item=>{
        return {...item, content:{...item.content, richText: this.getRichText(item.id) || item.content.richText, text: this.getRichText(item.id) || item.content.text}}
      })
      if (order[0] && order[0].length) {
        order.forEach(element => {
          let issueItem = issueItems.find(item => item.id == element)
          checkedArr.push(
            Object.assign(
              {},
              {
                item: issueItem,
                order: checkedArr.length + 1
              }
            )
          )
        })
      }
      issueItems.forEach(it => {
        !order.includes(it.id) && noCkeckedArr.push(Object.assign({}, { item: it }))
      })
      return [...checkedArr, ...noCkeckedArr]
    },

    getMax() {
      let maxLen = this.rowData.questionDetails.issue.max_choice
      if (maxLen && maxLen >= 0) {
        return maxLen
      } else {
        return this.rowData.questionDetails.issue.items.length
      }
    }
  },
  mounted() {
    this.getModel()
  },
  inject: ['transformHtml'],
  methods: {
    changeChecked() {
      this.rowData.items = []
      this.checkboxGroup.forEach(element => {
        let issueItem = this.rowData.questionDetails.issue.items.find(item => item.id == element)
        this.rowData.items.push(
          Object.assign({}, itemInitOptions, {
            optionId: issueItem.id,
            value: this.getRichText(issueItem.id) || issueItem.content.text
          })
        )
      })
      // if(this.updateArr.findIndex(it => it.questonId === this.rowData.questonId) === -1){
      //   this.updateArr.push(this.rowData);
      // }
      this.saveArr()
    },
    getImg(item) {
      var answerArr = []
      if (item && item.content && item.content.image && item.content.image[0]) {
        item.content.image.forEach(element => {
          answerArr.push(this._getDownloadUrl(element.url))
        })
      }
      return answerArr
    },
    stopDefault(e) {
      e.stopPropagation()
    },
    getModel() {
      const items = this.rowData.items || []
      if (Array.isArray(items) && items.length > 0) {
        this.checkboxGroup = items.map(item => {
          return item.optionId
        })
      }
    },
    saveArr
  }
}
</script>

<style lang="scss" scoped>
// 排序题样式
.ranking-question-box {
  .chosen {
    .item {
      padding: 6px;
      background-color: #fdfdfd;
      border: solid 1px #eee;
      margin-bottom: 10px;
      cursor: move;
      display: flex;
      align-items: center;
    }
    .item:hover {
      background-color: #f1f1f1;
      cursor: move;
    }
  }
}
::v-deep.el-checkbox {
  margin: 0;
  // display: block;
  display: block;
  height: auto;
}
::v-deep.el-checkbox.is-bordered.is-checked {
  height: auto;
}
::v-deep.el-checkbox.is-bordered.el-checkbox--small {
  height: auto;
}
::v-deep.el-checkbox__label {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::v-deep.el-checkbox__input {
  display: none;
}
.round {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 50%;
  text-align: center;
  line-height: 22px;
  font-size: 14px;
  color: #fff;
}
.activeRound {
  border: 1px solid rgb(48, 117, 252);
  background: rgb(48, 117, 252);
}
.___img-class {
  flex: 1;
  height: auto;
  white-space: normal;
  line-height: initial;
  img {
    width: 20px !important;
    height: 20px !important;
  }
}
</style>
